export const DEFAULT_PITCH = 0;

export const DEFAULT_TEMPO = 1.2;

export const DEFAULT_EMOTION = 'normal';
